// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"15b00e87","72":"aead414d","169":"d8783581","464":"9f37c029","511":"dadd4b4f","582":"4c39866d","713":"89184578","861":"f5be7f25","900":"0842eaf9","930":"b46aaff1","995":"efe73c66"}[chunkId] + ".chunk.js";
};